import React from "react";
import { animated, useChain, useSpringRef, useTransition } from "react-spring";
import styled from "styled-components";
import { Menus } from "./Header";

const Container = styled.div`
  z-index: 49;
  background: black;
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 10rem;
  bottom: 0;
  right: 0;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Menu = styled.div<{ active: boolean }>`
  font-size: 28px;
  color: ${({ active }) => (active ? "#ea3d61" : "white")};
  font-weight: bold;
  margin-top: 4.2rem;
`;

interface Props {
  drawerOpen: boolean;
  onClickMenu: (index: number) => void;
  currentSection: number;
}
function Drawer({ drawerOpen, onClickMenu, currentSection }: Props) {
  const transitionRef = useSpringRef();
  const transitions = useTransition(Array.from(Array(Menus.length).keys()), {
    ref: transitionRef,
    from: { opacity: 0, transform: "translateY(30px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    trail: 100,
  });

  useChain(drawerOpen ? [transitionRef] : []);

  return (
    <Container>
      {transitions((style, index) => (
        <animated.div style={style}>
          <Menu
            active={currentSection - 1 === index}
            onClick={() => {
              onClickMenu(index);
            }}
          >
            {Menus[index]}
          </Menu>
        </animated.div>
      ))}
    </Container>
  );
}

export default Drawer;
